import * as Comlink from "comlink";
import { useEffect, useState, useRef } from 'react'
import { Button, Collapse, Stack, TextField, Typography, Avatar } from '@mui/material';
// @ts-ignore
import { useUserContext } from '../../../context/UserContext.tsx';
import Iconify from '../../../components/iconify';
import * as apis from '../../../utils/apirequests.js'
import robinhoodImg from '../../../images/robinhood.png'


function Venmo({ onNotarizationComplete, extensionFound }) {
  const userUuid = useRef<string | null>(null)
  const sessionInfo = useRef({
    token: null,
    expiresAt: 0,
  })
  const { user, session } = useUserContext()

  const [credentialEnabled, setCredentialEnabled] = useState(true)
  const [loading, setLoading] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const [loadingFailed, setLoadingFailed] = useState(false)
  const [loadingText, setLoadingText] = useState("")
  const [notarizeDetails, setNotarizeDetails] = useState("")
  const [verifiedData, setVerifiedData] = useState(null)
  const [verifiedTimestamp, setVerifiedTimestamp] = useState(null)
  const [uniqueId, setUniqueId] = useState(null);

  const notarizeDetailedText = useRef("")

  async function notarizeRequest(server, path, method, data, headers, keysToNotarize) {
    // TODO: Get a new websocket proxy based on server

    return new Promise((resolve, reject) => {
      console.log("start notarizeRequest")
      const worker = new Worker("./wasm_worker.js", { type: "module" });
      var subworkers = []

      worker.onmessage = async function (e) {
        if (e.data.type === "wasm_bindgen_worker_init") {
          const worker_s = new Worker("./wasm_worker.js", { type: "module" });
          subworkers.push(worker_s)
          const subworker = Comlink.wrap(worker_s);
          // @ts-ignore
          subworker.startSubworker(e.data);
        } else if (e.data.type === "notarize_result") {
          worker.terminate()
          subworkers.map((subw) => subw.terminate())
          if (e.data.error) {
            reject(e.data.error)
          } else {
            resolve({
              "session_proof": e.data.sessionProof,
              "substrings_proof": e.data.substringsProof,
            })
          }
        } else if (e.data.type === "notarize_process_details") {
          notarizeDetailedText.current = notarizeDetailedText.current + new Date(Date.now()).toLocaleTimeString() + ": " + e.data.message + "\n"
          setNotarizeDetails(notarizeDetailedText.current)
        }
      }

      const notarizer = Comlink.wrap(worker);
      // @ts-ignore
      notarizer.notarize(
        server, path, method, JSON.stringify(data), headers, keysToNotarize,
        "wss://notary.jomo.id:61288",
        "wss://notary.jomo.id:61291",
      );
    })
  }

  async function notarizeVenmoStories() {
    setCredentialEnabled(false)
    setLoading(true)
    setLoadingText("Logging in...")

    // @ts-ignore
    chrome.runtime.sendMessage(
      "nmdnfckjjghlbjeodefnapacfnocpdgm",
      {
        type: "prepareSession",
        redirectUrl: "https://account.venmo.com/",
        urlFilters: ["https://account.venmo.com/api/stories*"]
      },
      {},
      (response) => {
        const cookieHeader = response.headers.Cookie
        notarizeWithAuthentication(cookieHeader)
      },
    )
  }


  async function notarizeWithAuthentication(cookieHeader) {
    const server = "account.venmo.com"

    const headersWithBearer = new Map([
      ["Cookie", cookieHeader],
      ["Host", server],
      ["Accept", "application/json, text/javascript, */*; q=0.01"],
    ])

    setLoadingText("Fetching and notarizing data from Venmo ...")

    const dataPath = `api/stories?feedType=betweenYou&otherUserId=1388181958164480879&externalId=2770628205608960739`
    const dataMethod = "GET"
    const keysToNotarize = [["stories"]]
    const notarizationProof = await notarizeRequest(server, dataPath, dataMethod, {}, headersWithBearer, keysToNotarize)
    console.log("success")
    console.log(JSON.parse(notarizationProof["session_proof"]))
    console.log(JSON.parse(notarizationProof["substrings_proof"]))

    let res = await apis.backendRequest("generate_notary_attestation", {
      attestation_name: "p2p_transaction",
      session_proof: notarizationProof["session_proof"],
      substrings_proof: notarizationProof["substrings_proof"],
    })
    if (res && res.validated) {
      setVerifiedData(res.raw_elements)
      setVerifiedTimestamp(res.attestation.sig.message.time)
      setUniqueId(res.unique_id)
      setLoaded(true)
      onNotarizationComplete(res)
    } else {
      setLoadingFailed(true)
    }
    setLoading(false)
  }

  // Whenever local user state finds a new userUuid, get a valid token for the user
  useEffect(() => {
    if (user) {
      userUuid.current = user.userUuid
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  // Whenever global session updates, update the local ref
  useEffect(() => {
    sessionInfo.current = session
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session])

  useEffect(() => {
    const areas = document.getElementsByClassName("MuiInputBase-inputMultiline")
    if (notarizeDetails) {
      for (var i = 0; i < areas.length; i++) {
        const area = areas.item(i)
        area.scrollTop = area.scrollHeight
      }
    }
  }, [notarizeDetails]);

  return (
    <Stack gap={2}>
      <Stack direction={"row"} gap={2} alignItems={"center"}>
        {!loaded &&
          <Stack minHeight={36} minWidth={36} borderRadius={5} border={"1px solid"} alignItems={"center"} justifyContent={"center"}>
            <Iconify height={20} width={20} icon="ri:number-1" />
          </Stack>
        }
        {loaded &&
          <Stack minHeight={36} minWidth={36} borderRadius={5} alignItems={"center"} justifyContent={"center"}>
            <Iconify height={36} width={36} icon="material-symbols:check" />
          </Stack>
        }
        {!loaded &&
          <Typography variant="body1" textAlign="left">
            Login to Venmo to prove your transaction history
          </Typography>
        }
        {loaded &&
          <Typography variant="body1" textAlign="left">
            Successfully Fetched and Notarized
          </Typography>
        }

      </Stack>
      {!loaded &&
        <Stack alignItems={"center"} paddingLeft={2}>
          <Collapse in={credentialEnabled} sx={{ width: 1, maxWidth: "450px" }}>
            <Stack alignItems={"center"} sx={{ width: 1, maxWidth: "450px" }} spacing={2}>
              <Button disabled={loading} variant="contained" onClick={() => { notarizeVenmoStories() }}>Login Venmo and Prove</Button>
            </Stack>
          </Collapse>
          <Collapse in={loading} sx={{ width: 1, maxWidth: "450px", alignContent: "center" }}>
            <Typography variant="body1" textAlign={"center"}>{loadingText}</Typography>
          </Collapse>
          <Collapse in={loadingFailed}>
            <Typography variant="body1">Failed to fetch data</Typography>
          </Collapse>
        </Stack>
      }
      {notarizeDetails &&
        <TextField
          size="small"
          fullWidth
          multiline
          minRows={3}
          maxRows={10}
          margin="dense"
          variant="outlined"
          label="Notarization process details"
          value={notarizeDetails}
          contentEditable={false}
          onChange={(event) => { event.target.scrollTo(0, event.target.scrollHeight) }}
        />
      }
      {loaded &&
        <Stack gap={1} alignItems={"left"} paddingX={5} width={1}>
          <Stack direction="row" spacing={1} alignItems='center'>
            <Avatar alt="Venmo" src={robinhoodImg} sx={{ width: 24, height: 24 }} />
            <Typography gutterBottom variant="h6" component="div">
              Venmo
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems='center' justifyContent={"space-between"}>
            <Typography variant="subtitle2">
              Randomized Unique Id
            </Typography>
            <Typography variant="body2">{uniqueId}</Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems='center' justifyContent={"space-between"}>
            <Typography variant="subtitle2">
              Gross Income
            </Typography>
            <Typography variant="body2" color={(verifiedData[2] === "0" && verifiedData[3] !== "0") ? "text.stockdown" : "text.stockup"}>
              {(verifiedData[2] === "0" && verifiedData[3] !== "0") ? "Down" : "Up"} {parseFloat(verifiedData[2] === "0" ? verifiedData[3] : verifiedData[2]) / 100.0}%
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} alignItems='center' justifyContent={"space-between"}>
            <Typography variant="subtitle2">
              Notarized
            </Typography>
            <Typography variant="body2">{new Date(verifiedTimestamp * 1000).toDateString()}</Typography>
          </Stack>
        </Stack>
      }
    </Stack>
  )
}

export default Venmo
